import { getIdTokenLocalStorage } from '@sbgsports/vault-sso-auth';

import { vaultApi } from './http';

export async function getAssetFromApi(id) {
  const token = getIdTokenLocalStorage();
  vaultApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  try {
    const response = await vaultApi.get(`/assets/${id}`);
    return response.data.data;
  } catch (e) {
    console.log(`Error fetching asset details for assetId ${id} from API`, e);
    return null;
  }
}

export async function getSecurityProfilesFromApi() {
  const token = getIdTokenLocalStorage();
  vaultApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await vaultApi.get('/securityprofiles');
  return response.data.data;
}

export async function getMetaTagsFromApi() {
  const token = getIdTokenLocalStorage();
  vaultApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await vaultApi.get('/metaTags');
  return response.data.data;
}

export async function getVideoSourceFromPreview(id) {
  const token = getIdTokenLocalStorage();
  vaultApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await vaultApi.get(`/assets/preview/${id}`);
  return response.data.data;
}

export async function getThumbnailRendition(id) {
  const token = getIdTokenLocalStorage();
  vaultApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await vaultApi.get(`/assets/thumbnail/${id}`);
  return response.data.data;
}

export async function putThumbnailRendition(id, offset) {
  const token = getIdTokenLocalStorage();
  vaultApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await vaultApi.put(`/assets/thumbnail/${id}?offset=${offset}`);
  return response.data;
}

export async function getLiveVideoUrl(id) {
  const token = getIdTokenLocalStorage();
  vaultApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await vaultApi.get(`/assets/live/${id}`);
  return response.data.data;
}

// VV-539: /assets/full logs every call now — `includeLog` was opt-in and the only caller
// that ever opted in was the C# Exchange Console, so every request from this client got a
// full-resolution URL with no audit row at all.
// `purpose` says what the caller is doing with the URL so the log row is honest:
// 'view' for rendering it in-app, 'probe' for a rendition-availability check. It defaults
// to 'download', the heavier reading, so an un-updated caller is never under-recorded.
export async function getAssetFullRendition(id, purpose = 'download') {
  const token = getIdTokenLocalStorage();
  vaultApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await vaultApi.get(`/assets/full/${id}?purpose=${purpose}`);
  return response.data.data;
}
